/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Onlyverified2Inputs */

const id_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya Terverifikasi`)
};

const ms_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya Disahkan`)
};

const da_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kun Bekræftede`)
};

const de_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Verifizierte`)
};

const en_us2_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only Verified`)
};

const es_es2_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo verificadas`)
};

const es_mx2_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo verificadas`)
};

const fil_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na-verify Lang`)
};

const fr_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifiés uniquement`)
};

const it_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo verificate`)
};

const hu_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csak hitelesített`)
};

const nl_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen geverifieerd`)
};

const no_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bare bekreftede`)
};

const pl_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tylko zweryfikowane`)
};

const pt_br2_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas verificado`)
};

const pt_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas verificadas`)
};

const ro_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doar verificate`)
};

const fi_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vain vahvistetut`)
};

const sv_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endast verifierade`)
};

const vi_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ đã xác minh`)
};

const tr_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca Doğrulanmış`)
};

const cs_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pouze ověřené`)
};

const bg_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Само проверени`)
};

const ru_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только подтверждённые`)
};

const uk_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лише перевірені`)
};

const ar_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الموثقة فقط`)
};

const hi_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केवल सत्यापित`)
};

const th_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยืนยันแล้วเท่านั้น`)
};

const ja_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認済みのみ`)
};

const zh_cn2_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅限已验证`)
};

const zh_hant1_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`僅限已驗證`)
};

const ko_offerdetail_reviews_onlyverified2 = /** @type {(inputs: Offerdetail_Reviews_Onlyverified2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인증된 리뷰만`)
};

/**
* | output |
* | --- |
* | "Only Verified" |
*
* @param {Offerdetail_Reviews_Onlyverified2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_onlyverified2 = /** @type {((inputs?: Offerdetail_Reviews_Onlyverified2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Onlyverified2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "da") return da_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "de") return de_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "it") return it_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "no") return no_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "th") return th_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_onlyverified2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_onlyverified2(inputs)
	return ko_offerdetail_reviews_onlyverified2(inputs)
});
export { offerdetail_reviews_onlyverified2 as "offerDetail.reviews.onlyVerified" }